/**
 * Clubs that issue Thai tax documents through FlowAccount from the admin.
 *
 * Mirrors the backend platform switch `FLOWACCOUNT_ENABLED_CLUB_IDS`
 * (backend_bookandgo/src/common/services/flowaccountEnabledClubs.ts). Kept here
 * only so other clubs never make a request or see a button; whether documents
 * are actually issued is the backend's call (its row switch and connection).
 */
export const FLOWACCOUNT_TAX_DOCUMENT_CLUB_IDS: number[] = [129];

export const isFlowAccountTaxDocumentClub = (clubId: unknown): boolean =>
  FLOWACCOUNT_TAX_DOCUMENT_CLUB_IDS.includes(Number(clubId));
